import JSXComponent from "../../../../dist/jsx-render/JSXComponent";
import dom from "../../../../dist/jsx-render/dom";
import { WidgetMeasuresByStatus, WidgetMeasuresByStatusColumnFilter } from "../Widgets/WidgetMeasuresByStatus";
import { SortType } from "../Widgets/WidgetBase";
import { IWidgetComponent } from "./IWidgetComponent";
import { MeasureTextProvider } from "./Util/MeasureTextProvider";
import { app, App } from "../../../Frame/App";
import { MeasuresByStatusDto } from "./WidgetMeasuresByStatus/MeasuresByStatusDto";
import { DesignParser } from "./Util/DesignParser";
import { ITableColumn } from "../../Table/ITableColumn";
import { Columns } from "../../Table/Columns";
import { MeasureEditFactory } from "../../../Pages/Measure/MeasureEditFactory";
import { PopupCloseType, PagePopup } from "../../PagePopup";

export type WidgetMeasuresByStatusComponentProps = {
    widget: WidgetMeasuresByStatus;
    markupHeader: string;
    markupItems: string;
    styles: string;
    clientId: string;
    templateId: string;
    additionalFilter: string;
    columnFilters: WidgetMeasuresByStatusColumnFilter[];
    rowClickLayoutId: number;
    rowClickURL: string;
    rowClickUrlUsePopup: boolean;
    sortFirst: string;
    sortFirstAsc: SortType;
    sortSecond: string;
    sortSecondAsc: SortType;
}

export class WidgetMeasuresByStatusDto {
    public columnFilters: WidgetMeasuresByStatusColumnFilter[];
    public placeholders: string[];
    public additionalFilter: string;
    public templateIds: string;
    public sortFirst: string;
    public sortFirstAsc: SortType;
    public sortSecond: string;
    public sortSecondAsc: SortType;
    public singleId: number;
}
export class WidgetMeasuresByStatusComponent extends JSXComponent implements IWidgetComponent {
    props: WidgetMeasuresByStatusComponentProps;

    constructor(props: WidgetMeasuresByStatusComponentProps) {
        super(props);
    }

    element: HTMLElement;
    getElement = () => {
        this.element = <div className={`widget Background-Blur-90-MSO m-b-c ${this.props.clientId}`}>
            <div className="content-row flex-row ">
            </div>
        </div>;
    }

    private getData = (newMeasureId?: number) => {
        let url = `~/api/measure/getMeasuresByStatus`;

        var dto = new WidgetMeasuresByStatusDto();
        dto.additionalFilter = this.props.additionalFilter;
        dto.columnFilters = this.props.columnFilters;
        dto.placeholders = MeasureTextProvider.getPlaceHolders(this.props.markupItems);
        dto.templateIds = this.props.templateId;
        dto.sortFirst = this.props.sortFirst;
        dto.sortFirstAsc = this.props.sortFirstAsc;
        dto.sortSecond = this.props.sortSecond;
        dto.sortSecondAsc = this.props.sortSecondAsc;
        dto.singleId = newMeasureId;

        $.ajax({
            url: app.resolveUrl(url),
            method: "POST",
            data: JSON.stringify(dto),
            contentType: "application/json",
            success: (response) => {
                console.log(response);

                if (Array.isArray(response)) {
                    this.renderData(response, (newMeasureId ? true : false));
                }
            },
            error: (err) => {
                console.log(err);
            }
        });
    }

    private renderData = (data: MeasuresByStatusDto[], append: boolean) => {
        const contentRow = this.element.querySelector(".content-row") as HTMLDivElement;

        for (let dto of data) {

            let contentItem: HTMLElement
            if (!append) {
                contentItem = <div className="content-item flex-column" data-name={dto.templateBlockName}></div>;
            } else {
                contentItem = this.element.querySelector(`.content-item[data-name="${dto.templateBlockName}"]`) as HTMLElement;
            }

            if (!append) {
                let contentHeader: HTMLElement = <div className={`content-header ${dto.templateBlockName}`}></div>;
                contentHeader.style.backgroundColor = dto.contentColor;

                var markup = this.props.markupHeader;
                markup = this.replaceText(markup, dto, null);

                DesignParser.parseDesign(contentHeader, markup);
                contentItem.appendChild(contentHeader);
                contentItem.style.width = `${(100 / data.length).toFixed(4)}%`
            }

            let measureItems: HTMLElement;
            if (!append) {
                measureItems = <div className="measure-items"></div>;
                contentItem.appendChild(measureItems);
            } else {
                measureItems = contentItem.querySelector(".measure-items") as HTMLElement;
            }

            for (let row of dto.tableDefinition.data) {
                let markup = this.props.markupItems;
                markup = this.replaceText(markup, row, dto);

                let measureItem: HTMLDivElement = <div className="measure-item" data-id={row["Id"]}></div>;
                DesignParser.parseDesign(measureItem, markup);
                measureItem.addEventListener("click", this.onMeasureClick);

                measureItems.appendChild(measureItem);
            }

            if (!append) {
                contentRow.appendChild(contentItem);
            }

        }
    }

    private replaceText = (text: string, dataRow: { [id: string]: any; }, data: MeasuresByStatusDto): string => {
        text = MeasureTextProvider.replaceConditionals(text, dataRow);
        let placeholders = MeasureTextProvider.getPlaceHolders(text);
        for (let placeholder of placeholders) {

            let columnDef: ITableColumn;
            if (data) {
                columnDef = data.tableDefinition.columns.find(c => c.dataField == placeholder);
            }

            if (columnDef) {
                let columns = new Columns();
                let col = columns.getColumnByType(null, columnDef, "");

                if (col) {
                    // create HTML
                    let element = col.createCell(dataRow, "ID");
                    // get HTML String
                    let htmlString = element.outerHTML;

                    // Insert in text
                    text = MeasureTextProvider.replace(text, placeholder, htmlString);
                }
            }
            else {
                text = MeasureTextProvider.replace(text, placeholder, dataRow[placeholder] ?? "");
            }
        }

        return text;
    }

    private onMeasureClick = (ev: MouseEvent) => {
        let measureItem = (ev.target as HTMLElement).closest(".measure-item") as HTMLDivElement;
        let id = measureItem.getAttribute("data-id");

        let header = (ev.target as HTMLElement).closest(".content-item") as HTMLDivElement;
        let name = header?.getAttribute("data-name");

        if (this.props.rowClickLayoutId) {
            let url = `~/measures/WidgetCockpit?layoutId=${this.props.widget.props.rowClickLayoutId}&parentId=${id}&headline=${encodeURI(name)}`;
            let resolvedUrl = app.resolveUrl(url);
            console.log(resolvedUrl)
            window.location.href = app.resolveUrl(resolvedUrl);

        } else if (!app.isNullOrUndefined(this.props.rowClickURL) && this.props.rowClickURL != "") {
            var url = app.resolveUrl(this.props.rowClickURL.replace("{id}", id));
            if (this.props.rowClickUrlUsePopup) {
                const popup = new PagePopup({
                    url: url,
                    resultId: parseInt(id),
                    showCloseButton: false,
                    fullScreen: true,
                    onClose: (reason: PopupCloseType, id: number): boolean => {
                        if (reason == "save") {
                            document.location = document.location;
                        }
                        return true;
                    }

                });
            } else {
                document.location.href = url;
            }
        } else {
            MeasureEditFactory.showMeasure({
                measureId: parseInt(id),
                templateId: 0,
                parentId: 0,
                parentGuid: null,
                fullScreen: true,
                onClose: ((reason: PopupCloseType, id: number) => {
                    document.location = document.location;
                })
            });
        }
    }


    private parseStyles = () => {
        DesignParser.appendStyles(this.props.clientId, this.props.styles);
    }

    public addNewMeasure = (id: number) => {
        this.getData(id);
    }

    render(): HTMLElement {
        this.getElement();
        this.props.widget.setGridPosition();
        this.parseStyles();

        this.getData();

        App.activeWidgets.push(this);
        console.log(App.activeWidgets);

        return this.element;
    }

}